import { createApp } from 'vue'
import options from './InfoCarousel.options'

const el = '.kb-component--info-carousel'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((InfoCarouselDOM) => {
            if (InfoCarouselDOM.hasAttribute('data-v-app')) return false
            const template = InfoCarouselDOM.innerHTML
            options.template = template
            const component = createApp(options).use(Store)
            component.mount(InfoCarouselDOM)
        })
    }
}
